module.exports = __webpack_public_path__ + "img/ap8logo.d67aaae1.svg";